<template>
  <div>
    <div class="tip">
      <img src="./assets/xcx-tgo.jpg" alt="">
      <div class="tip-word">
        <p>请在微信小程序中搜索</p>
        <p>“TGO 鲲鹏会学员服务”</p>
        <p>或在微信环境下扫码查看</p>
      </div>
    </div>
  </div>
</template>
<script>
import weixinshare from '@/util/weixinshare'

export default {
  data () {
    return {}
  },
  created () {},
  mounted () {
    weixinshare({
      title: 'TGO 鲲鹏会 | 最新活动动态',
      desc: '第一时间了解全球活动动态'
    })
  }
}
</script>
<style scoped lang='sass'>

.tip
  text-align: center
  width: 70%
  margin: 0 auto
  height: 70vh
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  img
    width: 100px
  .tip-word
    margin-top: 20px
</style>
